import { render, staticRenderFns } from "./PublicIdCheckVeracity.vue?vue&type=template&id=27e038de&scoped=true&"
import script from "./PublicIdCheckVeracity.vue?vue&type=script&lang=js&"
export * from "./PublicIdCheckVeracity.vue?vue&type=script&lang=js&"
import style0 from "./PublicIdCheckVeracity.vue?vue&type=style&index=0&id=27e038de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e038de",
  null
  
)

export default component.exports